<template>
  <div class="content-wrapper">
    <div class="container">
      <v-row>
        <v-col>
            <div id="modalPrint">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                    <div class="modal-header">
                    <h4 class="modal-title">Impresion de guía aerea</h4>
                    <p></p></div>
                    <div class="modal-body" id="billdata">
                    <p></p>
                    <div class="row">
                    <div class="col-sm-6"><img src="images/logo.jpg" width="200" height="43"></div>
                    <div class="col-sm-6">
                    <div class="text-center">
                          <barcode v-bind:value="guia != null ? guia.guia_interna: ''"  v-bind:height="25">
                            Error al generar barcode
                          </barcode>
                          <span v-if="guia.tipoguia == 'nacional'">DOMESTICO</span>
                    </div>
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-sm-6" style="font-size: 9px">
                    <div>
                        <h6 v-if="guia.tipoguia != 'importacion'" style="font-weight: bold;">Enviador/Shipment From: </h6><h6 v-else style="font-weight: bold;">Picked Up/Recogido desde: </h6>
                        <div id="s0" v-if="guia.tipoguia != 'importacion'"><label>Cuenta/Account:</label> {{guia.cuenta}}</div>
                        <div id="s1"><label>Empresa/Company name:</label> {{guia.empresa_e}}</div>
                        <div id="s2"><label>Contacto/Contact name:</label> {{guia.contacto_e}}</div>
                        <div id="s2"><label>RUC/VAT ID:</label> {{guia.nit_e}}</div>
                        <div id="s3"><label>Dirección/Address:</label> {{guia.direccion1_e}} {{guia.direccion2_e}} {{guia.direccion3_e}}</div>
                        <div id="s6"><label>Correo/Email:</label> {{guia.correo_e}}</div>
                        <div id="s6"><label>País/Country:</label> {{guia.pais_e}}</div>
                        <div id="s7"><label>Ciudad/City:</label> {{guia.ciudad_e}}</div>
                        <div id="s72"><label>Código Postal/ZIP code:</label> {{guia.zip_e}}</div>
                        <div id="s8"><label>Teléfono/Telephone:</label> {{guia.telefono_e}}</div>
                    </div>
                    </div>
                    <div class="col-sm-6" style="font-size: 9px">
                    <h6 style="font-weight: bold;">Consignatario/Shipment To: </h6>
                        <div id="c1"><label>No.Identificación/Vat:</label> {{guia.nit_c}}</div>
                        <div id="c1"><label>Empresa/Company name:</label> {{guia.empresa_c}}</div>
                        <div id="c2"><label>Contacto/Contact name:</label> {{guia.contacto_c}}</div>
                        <div id="s2"><label>RUC/VAT ID:</label> {{guia.nit_c}}</div>
                        <div id="c3"><label>Dirección/Address:</label> {{guia.direccion1_c}} {{guia.direccion2_c}} {{guia.direccion3_c}}</div>
                        <div id="c6"><label>Coreo/Email:</label> {{guia.correo_c}}</div>
                        <div id="c6"><label>País/Country:</label> {{guia.pais_c}}</div>
                        <div id="c7"><label>Ciudad/City:</label> {{guia.ciudad_c}}</div>
                        <div id="c7"><label>Código Postal/Zip code:</label> {{guia.zip_c}}</div>
                        <div id="c8"><label>Teléfono/Telephone:</label> {{guia.telefono_c}}</div>
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-sm-6" style="font-size: 9px">
                    <h6 style="font-weight: bold;">Detalles del envío/Shipment Details:</h6>
                        <div><label>Fecha del envío/Shipment Date:</label><span> {{formatedDate}}</span></div>
                        <div><label>Número de guía/Waybill Number:</label><span> {{guia.guia_interna}}</span></div>
                        <div><label>Tipo de servicio/Service Type:</label><span> {{guia.servicio}}</span></div>
                        <div><label>Tipo de Empaque/Packaging Type:</label><span> {{guia.embalaje}}</span></div>
                        <div><label>Número de piezas/Number of Pieces:</label><span> {{guia.piezas}}</span></div>
                        <div><label>Peso Total/Total Weight: </label><span> {{guia.paquetes[0].peso_r == null ?
                        guia.peso :
                        guia.paquetes.reduce((sumP, item) => sumP + parseFloat(item.pesototal_r),0)}} {{guia.unidad_m}} {{guia.paquetes[0].peso_r == null ? '' : '(RPP)'}} </span></div>
                        <div><label>Peso Dimensional/Dimensional: </label><span> {{guia.volumen}} {{guia.unidad_m}}</span></div>
                    </div>
                    <div class="col-sm-6" style="font-size: 9px">
                    <h6 style="color: white;">.</h6>
                    <div><label>Valor declarado/Value: </label><span> {{guia.valor}} {{guia.moneda}}</span></div>
                    <div><label>Tipo de producto/Type: </label><span> {{guia.tipo}}</span></div>
                    <div><label>Descripción/Description: </label><span> {{guia.descripcion}}</span></div>
                    <div v-if="guia.tipo == 'No Documento' && guia.tipoguia != 'nacional'">
                        <div><label>Cargos en destino cancelados en origen/DDP: </label><span> {{guia.pago}}</span></div>
                    </div>
                    <div><label>Seguro/Insurance: </label><span> {{guia.seguro}}</span></div>
                    <div><label>Terminos de Entrega/Incoterms: </label><span> {{guia.incoterms}}</span></div>
                    </div>
                    </div>

                    <div class="row">
                    <div class="col-sm-6" style="font-size: 9px">
                    <h6 style="font-weight: bold;">Información para facturación/Billing Information</h6>
                    <div><label>Cuenta Inexpress/Inexpress Account: </label><span> {{guia.cuenta}}</span></div>
                    <div><label>Tarifa/Tariff: </label><span>* Tarifa a aplicar según tarifario</span></div>
                    <div><label v-if="guia.tipoguia == 'nacional'">Ruta/Rute</label><label v-else>Zona/Zone: </label><span> {{guia.tipoguia == 'nacional' ? guia.rutaorig + ' - ' + guia.rutadest : (guia.tipoguia == 'importacion' ? guia.paisr.zona : guia.paisc.zona)}}</span></div>
                    <div><label>Tiempo de entrega/Delivery time: </label><span>**Tiempo de entrega de acuerdo a la zona donde se registre el lugar de destino</span></div>
                    </div>

                    <div class="col-sm-6" style="font-size: 9px">
                        <h6 style="font-weight: bold;">Descripción del contenido/Description of Contents</h6>
                        <div><label>Descripción/Description: </label><span> {{guia.descripcion}}</span></div>
                        <div v-if="guia.tipoguia != 'nacional'"><label>Partida arancelaria/Tariff number: </label><span></span></div>
                    </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12" style="font-size: 9px">
                            <h6 style="font-weight: bold;">Firmas requeridas/Required Signature</h6>
                        </div>
                        <div class="col-sm-6" style="font-size: 9px">
                            <div><label>Nombre y Firma del sender/Sender's signature and name: </label><span></span></div><br><br><br>
                        </div>
                        <div class="col-sm-6" style="font-size: 9px">
                            <div><label>Recibido por Inexpress /Received by INEXPRESS: </label><span></span></div><br><br><br>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12"></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6" style="font-size: 9px">
                            <div><label>Fecha/Date: __________________________________ </label><span></span></div>
                        </div>
                        <div class="col-sm-6" style="font-size: 9px">
                            <div><label>Fecha/Date: __________________________________ </label><span></span></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="text-center" style="font-size: 9px">Términos y condiciones de Transporte</div>
                        <div class="col-sm-12" style="font-size: 6px">
                            <p>El contenido y efectos de este contrato, es aceptado por las partes una vez que el Remitente haya firmado e INEXPRESS-COURIER S.A. haya recibido el envío con las especificaciones en el anverso del documento. El Remitente declara que acepta que IN EXPRESS COURIER S.A. tiene derecho y no obligación de revisar en cualquier momento y sin limitación alguna, los envíos y verificar los documentos que prueben la legalidad de los envíos.</p>
                            <p>1. El servicio comprenderá recepción, retiro de los documentos, paquetes y/o carga en el domicilio del Cliente IN EXPRESS-COURIER S.A. en sus oficinas ubicadas en el perímetro urbano en la ciudad de Quito y Guayaquil; transporte vía aérea o vía terrestre y entrega en domicilio del consignatario. Este servicio no incluye costos como: tramites, tributos, multas y/o impuestos aduanales, ni bodegaje privado en los diferentes destinos de los envíos de paquetería y/o carga realizados por parte del Cliente IN EXPRESS-COURIER S.A.</p>
                            <p>2. IN EXPRESS-COURIER S.A. salvo fuerza mayor o caso fortuito, responderán ante el usuario por incumplimiento de las condiciones de prestación de los servicios postales, a través de la indemnización correspondiente. En especial, están obligados a pagar una indemnización cuando el usuario sufra pérdida, robo, hurto, expoliación o avería de su envío postal</p>
                            <p>3. IN EXPRESS-COURIER S.A. aceptara cualquier tipo de reclamos por los envíos del Cliente IN EXPRESS-COURIER S.A. por escrito hasta 7 días después de haberse realizado el envío los mismos, que se analizarán y revisarán si corresponden a las causales de aceptación o no por parte del departamento correspondiente. De producirse el reclamo con fecha posterior a los 10 días dicho reclamo no tendrá ninguna validez y el envío deberá ser cancelado en su totalidad. Por lo cual In Express quedará eximida de toda responsabilidad.</p>
                            <p>Todo usuario tiene derecho a ser indemnizado en los siguientes casos:
                            Pérdida, avería, o expoliación de su envío   En el caso de haber asegurado su envío  IN EXPRESS-COURIER S.A.  Reembolsará el valor declarado + flete (este último en el caso de haber sido cancelado por el cliente. En caso de NO haber asegurado su envío,  IN EXPRESS-COURIER S.A.  deberá hacer la devolución solo del flete siempre y cuando haya sido cancelado por el cliente. Retraso no justificado IN EXPRESS-COURIER S.A.  deberá hacer la devolución solo del flete siempre y cuando  haya sido cancelado por el cliente Caso fortuito o fuerza  mayor    IN EXPRESS-COURIER S.A. no será responsable en caso de producirse atrasos o demoras en las entregas de los envíos por fallas técnicas, mal tiempo, situaciones de fuerza mayor, caos fortuitos, trámites aduaneros en destino o imprevistos que estén fuera del alcance de IN EXPRESS-COURIER S.A. IN EXPRESS-COURIER S.A. Tampoco será responsable por mercadería que no se encuentre con el correcto embalaje del cual el Cliente es el único responsable; IN EXPRESS-COURIER S.A. lo podrá asesorar mas no será responsable de la misma. Considerar que los términos de indemnizaciones por quejas o reclamos está acorde a lo estipulado por la Agencia de Regulación y control postal</p>
                            <p>4. No se aceptaran envíos de dinero en efectivo, joyas, metales y piedras preciosos, lingotes de oro, plata, envíos con droga, armas de fuego, instrumentos negociables al portador, restos humanos, pornografía, narcóticos, productos perecibles, peligrosos o restringidos por I.A.T.A. y todo lo estipulado sobre mercaderías prohibidas según los términos y condiciones generales de transporte IACAO ( International Civil Aviation Organization) y ADR ( European, road, transport, regulation on dangerous good). El remitente pagará o reembolsará a INEXPRESS-COURIER S.A. todos los cargos del envío, cargos de almacenamiento, aranceles e impuestos adeudados por los servicios prestados por INEXPRESS-COURIER S.A. y demás gastos incurridos en nombre del remitente, del destinatario o de cualquier tercero y todos los gastos de las reclamaciones, daños y perjuicios, multas y otros conceptos incurridos si el envío se considera inaceptable.</p>
                            <p>5. El remitente indemnizará y mantendrá indemne a INEXPRESS-COURIER S.A. de cualquier daño o pérdida que se derive del incumplimiento por parte del remitente de cualquier legislación o normativa aplicable y del incumplimiento por parte del remitente en las siguiente declaraciones:</p>
                            <p>-Toda la información indicada por el remitente o su representante es completa, exacta y veraz.</p>
                            <p>-El envío se encuentra correctamente identificado con dirección de destino correcta.</p>
                            <p>-El envío se encuentra correctamente embalado y con la distinción de frágil si fuere del caso o de postura de embalaje indicada.</p>
                            <p>-Todas las regulaciones de aduanas han sido cumplidas a cabalidad.</p>
                            <p>Declaramos expresamente que los datos consignados en esta guía por parte del cliente se encuentran protegidos salvo que por solicitud expresa de la autoridad competente o judicial sean solicitados</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 text-right" style="font-size: 6px">
                            <label>Elaborado por : {{guia.usuario.name}}</label>
                        </div>
                    </div>
                    </div>
                    <hr class="border">
                    <div class="modal-footer">
                        <v-checkbox v-model="duplicar" label="Duplicar"></v-checkbox>
                        <v-btn color="blue" @click="imprimirGuia()" outlined>Imprimir</v-btn><p></p>
                    </div></div>
                    <p></p></div>
            </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode';
import $ from 'jquery';
import apicon from '../plugins/apicon';
import utils from '../utils/utils';
export default {
  props: {
      id: {
      type: Number,
      default: null,
    }
  },
  components: {
    'barcode': VueBarcode
  },
  created: function () {},
  data() {
    return {
        duplicar: false,
        guia: null,
        empresa: null,
        isCliente: 1,
        formatedDate:null,
    };
  },
  methods: {
      fillDatosGuia:async function(){
      await apicon.getDataApi(apicon.getApiBaseUrl() + 'guias/' + this.id).then((result) => {
        this.guia = result;
      });
    },
    fillDatosEmpresa:async function(){
      await apicon.getDataApi(apicon.getApiBaseUrl() + 'empresa/1').then((result) => {
        this.empresa = result;
      });
    },
    imprimirGuia: function(){
      var mywindow = window.open('', 'tracking div', 'height=400,width=600');
      mywindow.document.write('<html><head><link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css"><link rel="stylesheet" href="css/print.css" media="print" /><link rel="stylesheet" href="css/bootstrap-print.min.css" media="print"/></head><body onload="window.print()">');
      //mywindow.document.write($("#billdata").html());
      // Wrap your bill data content with class "content" before writing
      if(this.duplicar){
        var billDataHtml = '<div>' + $("#billdata").html() + '</div><div>'+ $("#billdata").html() + '</div>';
      }else{
        var billDataHtml = '<div>' + $("#billdata").html() + '</div>';
      }
      mywindow.document.write(billDataHtml);
      mywindow.document.write('</body></html>');
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10
      setTimeout(function(){mywindow.close();}, 1000);
    },
  },
  mounted: async function() {
    apicon.setAuthHeaders();
    await this.fillDatosGuia();
    await this.fillDatosEmpresa();
    this.isCliente = localStorage.getItem('cliente');
    this.formatedDate = utils.formatDate(this.guia.created_at);
  },
};
</script>
<style scoped src="bootstrap/dist/css/bootstrap.css">

</style>
